import { TileMapLayer } from "core/tiles";
import { PropertyChangedEventArgs } from "core/events";
export class ElevationLayer extends TileMapLayer {
    constructor(name, provider, options, enabled) {
        super(name, provider, options, enabled);
    }
    get exageration() {
        return this._exageration;
    }
    set exageration(value) {
        if (this._exageration !== value) {
            const old = this._exageration;
            this._exageration = value;
            this.propertyChangedObservable.notifyObservers(new PropertyChangedEventArgs(this, old, value, ElevationLayer.ExagerationPropertyName));
        }
    }
    get offsets() {
        return this._offsets;
    }
    set offsets(value) {
        if (this._offsets !== value) {
            const old = this._offsets;
            this._offsets = value;
            this.propertyChangedObservable.notifyObservers(new PropertyChangedEventArgs(this, old, value, ElevationLayer.OffsetsPropertyName));
        }
    }
}
ElevationLayer.ExagerationPropertyName = "exageration";
ElevationLayer.OffsetsPropertyName = "offsets";
//# sourceMappingURL=dem.layer.js.map